import common from './common'
import dispatch from './apilist/dispatch'
import auth from './apilist/auth'
import service from './apilist/service'
import archives from './apilist/archives'
import calendar from './apilist/calendar'
import report from './apilist/report'
import h5View from './apilist/h5View'
import home from './apilist/home'
import monitor from './apilist/monitor'
import videoMonitor from './apilist/videoMonitor'
import oil from './apilist/oil'
import sensor from './apilist/sensor'
import adas from './apilist/adas'
import activeSafety from './apilist/activeSafety'
import dataScreen from './apilist/dataScreen'
import personal from './apilist/personal'

import apply from './apilist/apply'
import workStage from './apilist/workStage'

import weighbridge from './apilist/weighbridge'

/* 将所有接口统一起来便于维护
 * 如果项目很大可以将 url 独立成文件，接口分成不同的模块
 */

// 默认全部倒出
export default {
    ...common,
    ...dispatch,
    ...auth,
    ...service,
    ...archives,
    ...calendar,
    ...report,
    ...home,
    ...monitor,
    ...oil,
    ...videoMonitor,
    ...sensor,
    ...adas,
    ...activeSafety,
    ...dataScreen,
    ...personal,
    ...apply,
    ...h5View,
    ...workStage,
    ...weighbridge
}
